import Vue from 'vue'
import Vuex, {
  Commit as VuexCommit,
  CommitOptions,
  Dispatch as VuexDispatch,
  DispatchOptions
} from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({})

// Remove when https://github.com/vuejs/vuex/pull/1563 is merged
export type Commit = VuexCommit & {
  <P = any>(type: string, payload?: P, options?: CommitOptions): void
}

export type Dispatch = VuexDispatch & {
  <P = any, R = any>(
    type: string,
    payload?: P,
    options?: DispatchOptions
  ): Promise<R>
}
// End remove

export default store
export const dispatch: Dispatch = store.dispatch
export const commit: Commit = store.commit
